export function toWords(amount) {
  var converter = require('number-to-words');
  let amountAsText

  if (amount.includes('.')) {
    const parts = amount.split('.')
    const dollars = parts[0]
    const cents = parts[1]
    const dollarString = converter.toWords(dollars)
    const centString = converter.toWords(cents)
    amountAsText = dollarString + " dollars and " + centString + " cents"
  } else {
    amountAsText = converter.toWords(amount) + " dollars and no cents"
  }
  console.log("Amount as a string: ", amountAsText)
  return amountAsText
}